// modules/website/components/ContactFormComponent.tsx

import React, { useState } from 'react';
import { ContactFormData } from '@/types';
import { Send, CheckCircle } from 'lucide-react';

interface Props {
  data: ContactFormData;
  settings: any;
}

export const ContactFormComponent: React.FC<Props> = ({ data, settings }) => {
  const [formData, setFormData] = useState<Record<string, string>>({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    // Simular envio (implementar integração real depois)
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    setLoading(false);
    setSubmitted(true);
    
    // Redirecionar se configurado
    if (data.redirectUrl) {
      setTimeout(() => {
        window.location.href = data.redirectUrl!;
      }, 2000);
    }
  };

  if (submitted) {
    return (
      <div 
        className="py-20 px-6"
        style={{ backgroundColor: settings.backgroundColor || '#ffffff' }}
      >
        <div className="max-w-2xl mx-auto text-center">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
          <h3 className="text-3xl font-bold mb-4">Mensagem Enviada!</h3>
          <p className="text-xl text-gray-600">{data.successMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="py-20 px-6"
      style={{
        backgroundColor: settings.backgroundColor || '#ffffff',
        color: settings.textColor || '#000000',
      }}
    >
      <div className="max-w-2xl mx-auto">
        {data.title && (
          <h2 className="text-4xl font-bold text-center mb-12">
            {data.title}
          </h2>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-6">
          {data.fields.includes('name') && (
            <div>
              <label className="block text-sm font-medium mb-2">Nome *</label>
              <input
                type="text"
                required
                value={formData.name || ''}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Seu nome completo"
              />
            </div>
          )}

          {data.fields.includes('email') && (
            <div>
              <label className="block text-sm font-medium mb-2">Email *</label>
              <input
                type="email"
                required
                value={formData.email || ''}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="seu@email.com"
              />
            </div>
          )}

          {data.fields.includes('phone') && (
            <div>
              <label className="block text-sm font-medium mb-2">Telefone</label>
              <input
                type="tel"
                value={formData.phone || ''}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="(00) 00000-0000"
              />
            </div>
          )}

          {data.fields.includes('date') && (
            <div>
              <label className="block text-sm font-medium mb-2">Data Desejada</label>
              <input
                type="date"
                value={formData.date || ''}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          )}

          {data.fields.includes('message') && (
            <div>
              <label className="block text-sm font-medium mb-2">Mensagem *</label>
              <textarea
                required
                rows={5}
                value={formData.message || ''}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Escreva sua mensagem..."
              />
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-all"
          >
            {loading ? (
              <>
                <span className="animate-spin">⚙️</span>
                Enviando...
              </>
            ) : (
              <>
                <Send size={20} />
                {data.submitText}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};
